module.exports = __webpack_public_path__ + "static/media/cartoon_bg.7bf1700e.png";